import React from 'react'

const SvgBanFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M4.358 5.557l14.085 14.085A9.956 9.956 0 0112 22C6.486 22 2 17.514 2 12c0-2.453.887-4.702 2.358-6.443zm1.436-1.393A9.952 9.952 0 0112 2c5.514 0 10 4.486 10 10 0 2.343-.81 4.5-2.164 6.206L5.794 4.164z' />
  </svg>
)

export default SvgBanFilled
